import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1c1c1c",
    },
    secondary: {
      main: "#2f2f2f",
    },
    navbar: {
      color: "#0f0707ff",
      button: {
        color: "#ffffffff",
        hoverColor: "#ff0000ff",
      },
    },
  },
  typography: {
    h1: {
      fontSize: "3rem", fontWeight: 600,
    },
    h2: {
      fontSize: "1.75rem", fontWeight: 600,
    },
    h3: {
      fontSize: "1.5rem", fontWeight: 600,
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);